import React from "react";

function WebDev() {
  return (
    <main>

      {/* ===================== HERO ===================== */}
      <section className="position-relative pt-sm-8 pt-lg-9 pb-0 overflow-hidden mb-n6">
        <div className="bg-secondary-grad h-500px w-100 position-absolute bottom-0 start-0">
          {/* xml:space removed, style string → JSX object */}
          <span>
            <svg className="mt-n2" viewBox="0 0 1950 135" style={{ enableBackground: "new 0 0 1950 135" }}>
              <path className="fill-body" d="M1480.3,110.5c238.7,18.9,359.6-42.2,469.7-80.7V1.7L0,0v129.4c57.3-41.7,287.7-15.9,446.4,0 c170.6,17.1,342.3-15.8,440.8-35.8C1104,49.6,1274.8,94.2,1480.3,110.5z" />
            </svg>
          </span>
        </div>

        <div className="container position-relative" data-sticky-container>
          <div className="row">

            <div className="col-md-6">
              <nav className="mb-2" aria-label="breadcrumb">
                <ol className="breadcrumb pt-0">
                  <li className="breadcrumb-item"><a href="/">Home</a></li>
                  <li className="breadcrumb-item"><a href="/services">Services</a></li>
                  <li className="breadcrumb-item active" aria-current="page">Web Development</li>
                </ol>
              </nav>

              <h1 className="display-5 mb-5">Web design and development</h1>
              <a className="btn btn-dark icon-link icon-link-hover" href="/contact">
                Start a project<i className="bi bi-arrow-right"></i>
              </a>

              <div className="mt-5 mt-md-9">
                <h5>Overview</h5>
                <p>A brief introduction to your web development services. This can be a few sentences summarizing what you do and the unique value you bring to clients.</p>
                <p>At Arix Automation, we specialize in creating custom web solutions that drive business growth. Our expert team delivers cutting-edge websites tailored to meet your unique needs.</p>
                <p>Highlight the main benefits of our web development services. This helps visitors quickly understand why they should choose Arix Automation over competitors.</p>
              </div>
            </div>

            <div className="col-md-5 ms-auto">
              <div data-sticky data-margin-top="100" data-sticky-for="576">
                {/* style string → JSX object */}
                <div
                  className="rounded-4 h-400px h-lg-500px"
                  style={{ background: "url(assets/images/services/4by3/03.jpg) no-repeat", backgroundSize: "cover", backgroundPosition: "center" }}
                ></div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ===================== KEY BENEFITS ===================== */}
      <section className="bg-secondary-grad overflow-hidden mt-6 pt-7">
        <div className="container pb-8">

          <h5 className="mb-4">Key benefits</h5>

          <div className="row row-cols-1 row-cols-sm-2 row-cols-xl-4 g-4">
            {[
              { title: "Custom Design",           desc: "We create tailor-made websites that reflect your brand's identity and engage your audience." },
              { title: "Scalability",              desc: "Our solutions are built to grow with your business, ensuring long-term success." },
              { title: "Performance optimization", desc: "We ensure fast loading times and smooth user experiences to boost conversions." },
              { title: "SEO-friendly",             desc: "Our websites are optimized for search engines to help you rank higher and attract more traffic." },
            ].map((b, i) => (
              <div className="col" key={i}>
                <div className="card card-body h-100 rounded-3 p-4">
                  <h6 className="mb-3">{b.title}</h6>
                  <p className="mb-0">{b.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* ---- What's included ---- */}
          <div className="row g-4 mt-5 mt-md-7">

            <div className="col-lg-6 pe-lg-6">
              <img src="assets/images/services/01.jpg" className="rounded-4" alt="service" />
            </div>

            <div className="col-lg-6">
              <h2>What's included in web development?</h2>

              <div className="accordion accordion-icon accordion-icon-start mt-4" id="accordionWebDev">
                {[
                  { id: 1, open: true,  title: "Frontend development",             body: "We use the latest technologies like HTML5, CSS3, JavaScript, and frameworks such as React and Angular to create stunning interfaces that provide seamless user experiences across all devices." },
                  { id: 2, open: false, title: "Backend development",              body: "We build robust and scalable backend systems that power your website. Our expertise includes server-side scripting, database management, and API integration using technologies like Node.js, Python, Ruby on Rails, and PHP." },
                  { id: 3, open: false, title: "E-commerce solutions",             body: "Transform your business with our comprehensive e-commerce solutions. We develop custom online stores with features like product catalogs, shopping carts, payment gateways, and inventory management." },
                  { id: 4, open: false, title: "Content management systems (CMS)", body: "We offer custom CMS development and integration services to give you full control over your website content. Our expertise includes popular platforms like WordPress, Joomla, and Drupal." },
                  { id: 5, open: false, title: "Custom web applications",          body: "Our team develops bespoke web applications tailored to your specific business needs. Whether you need a custom CRM, ERP, or any other type of web application, we leverage the latest technologies to deliver results." },
                ].map((item) => (
                  <div className="accordion-item mb-2" key={item.id}>
                    <h6 className="accordion-header" id={`wd-heading-${item.id}`}>
                      <button
                        className={`accordion-button py-2${item.open ? "" : " collapsed"}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#wd-collapse-${item.id}`}
                        aria-expanded={item.open}
                        aria-controls={`wd-collapse-${item.id}`}
                      >
                        <span className="lead fw-bold">{item.title}</span>
                      </button>
                    </h6>
                    <div
                      id={`wd-collapse-${item.id}`}
                      className={`accordion-collapse collapse${item.open ? " show" : ""}`}
                      aria-labelledby={`wd-heading-${item.id}`}
                      data-bs-parent="#accordionWebDev"
                    >
                      <div className="accordion-body">{item.body}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>

          {/* ---- Technologies ---- */}
          <div className="inner-container text-center mt-7">
            <h4>Technologies used</h4>
            <ul className="list-inline d-flex justify-content-center flex-wrap gap-4 mt-4">
              {['08', '04', '12', '09', '05', '03', '02', '10'].map((n) => (
                <li className="list-inline-item me-0" key={n}>
                  <a href="#" className="icon-xl btn-transition bg-body d-flex justify-content-center align-items-center rounded-2">
                    <img src={`assets/images/client/icons/${n}.svg`} className="h-40px" alt="tech icon" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </section>

      {/* ===================== PROCESS ===================== */}
      <section className="pt-0 mt-n9">
        <div className="container-fluid position-relative">
          <div className="max-width-1550 bg-dark position-relative rounded-4 overflow-hidden py-5 py-sm-6 py-lg-8" data-bs-theme="dark">
            <div className="container position-relative">
              <h2 className="mb-4 mb-lg-6">Step-by-Step Process</h2>
              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
                {[
                  { num: "01", title: "Discovery & Planning",   desc: "We begin by understanding your business goals, target audience, and project requirements." },
                  { num: "02", title: "Design & Prototyping",   desc: "Our design team creates wireframes and prototypes based on the project plan." },
                  { num: "03", title: "Development",            desc: "In this phase, our developers bring the design to life using the latest technologies and best practices." },
                  { num: "04", title: "Testing & Launch",       desc: "Before going live, we conduct thorough testing to identify and fix any issues." },
                ].map((step) => (
                  <div className="col" key={step.num}>
                    <h4 className="text-primary-grad">{step.num}</h4>
                    <h6>{step.title}</h6>
                    <p className="mb-0">{step.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===================== PORTFOLIO SHOWCASE ===================== */}
      <section className="pt-0">
        <div className="container">
          <div className="row g-4">

            <div className="col-lg-4 text-center text-lg-start">
              <h2 className="mb-lg-4">Showcase of previous projects</h2>
              <p>Explore our diverse portfolio showcasing the range and quality of our web development projects.</p>
              <div className="d-flex justify-content-center justify-content-lg-start gap-3 position-relative mt-lg-4">
                <a href="#" className="btn btn-secondary btn-lg btn-icon rounded-circle mb-0 swiper-button-prev-team">
                  <i className="bi bi-arrow-left"></i>
                </a>
                <a href="#" className="btn btn-secondary btn-lg btn-icon rounded-circle mb-0 swiper-button-next-team">
                  <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>

            <div className="col-lg-8 ps-xl-6">
              <div className="swiper" data-swiper-options='{"spaceBetween":30,"autoplay":false,"navigation":{"nextEl":".swiper-button-next-team","prevEl":".swiper-button-prev-team"}}'>
                <div className="swiper-wrapper">
                  {[
                    { img: "01", logo: "01", title: "Corporate website for consulting",    stat: "40%", statLabel: "Increase in web traffic." },
                    { img: "03", logo: "05", title: "AI-Driven customer insights platform", stat: "60%", statLabel: "Increase in web traffic." },
                  ].map((p, i) => (
                    <div className="swiper-slide" key={i}>
                      <div className="card bg-secondary bg-opacity-50 rounded-4 overflow-hidden mb-3">
                        <div className="row g-0">
                          <div className="col-md-5">
                            <img src={`assets/images/portfolio/4by4/0${p.img}.jpg`} className="img-fluid rounded-start h-100" alt="project" />
                          </div>
                          <div className="col-md-7">
                            <div className="card-body d-flex flex-column align-items-start h-100 p-4">
                              <img src={`assets/images/client/logo-light/0${p.logo}.svg`} className="dark-mode-item h-30px mb-3" alt="client logo" />
                              <img src={`assets/images/client/logo-dark/0${p.logo}.svg`} className="light-mode-item h-30px mb-3" alt="client logo" />
                              <h6 className="card-title">{p.title}</h6>
                              <p className="card-text">Consulting wanted a professional online presence to attract high-profile clients.</p>
                              <div className="d-sm-flex justify-content-between align-items-center mt-auto w-100">
                                <div className="mb-3 mb-sm-0">
                                  <h4 className="text-primary-grad mb-0">{p.stat}</h4>
                                  <small>{p.statLabel}</small>
                                </div>
                                <a href="#" className="btn btn-sm btn-dark stretched-link mb-0">View detail</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ===================== TESTIMONIALS ===================== */}
      <section className="bg-body position-relative py-0">
        <div className="container position-relative z-index-9">

          <div className="row align-items-center mb-4 mb-md-5">
            <div className="col-md-7 col-xl-5">
              <h2 className="mb-0">Hear from our happy customers</h2>
            </div>
            <div className="col-md-5 ms-sm-auto text-sm-end mt-5 mt-sm-0">
              <div className="d-flex gap-2 justify-content-sm-end">
                <a href="#" className="btn btn-primary-grad btn-icon btn-lg rounded-circle mb-0 swiper-button-prev">
                  <i className="bi bi-arrow-left"></i>
                </a>
                <a href="#" className="btn btn-primary-grad btn-icon btn-lg rounded-circle mb-0 swiper-button-next">
                  <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="swiper" data-swiper-options='{"spaceBetween":30,"breakpoints":{"576":{"slidesPerView":1},"768":{"slidesPerView":2},"992":{"slidesPerView":3}},"navigation":{"nextEl":".swiper-button-next","prevEl":".swiper-button-prev"}}'>
            <div className="swiper-wrapper">
              {[
                { stars: 4.5, text: "Their team went above and beyond to understand our needs and deliver a solution that exceeded our expectations.", avatar: "09.jpg", name: "Jacqueline Miller", role: "Product designer" },
                { stars: 5,   text: "Frequently partiality possession resolution at or appearance unaffected me. Ye goodness felicity do disposal dwelling no.", avatar: "10.jpg", name: "Louis Ferguson",    role: "Web Developer" },
                { stars: 4.5, text: "Was out laughter raptures returned outweigh. Luckily cheered colonel I do we attack highest enabled. Tried law yet style child.", avatar: "04.jpg", name: "Emma Watson",       role: "UI/UX designer" },
                { stars: 4.5, text: "Our passion for customer excellence is just one reason why we are the market leader. We have always worked very hard.", avatar: "07.jpg", name: "Allen Smith",        role: "Manager" },
                { stars: 4.5, text: "Was out laughter raptures returned outweigh. Luckily cheered colonel I do we attack highest enabled. Tried law yet style child.", avatar: "01.jpg", name: "Emma Watson",       role: "UI/UX designer" },
              ].map((t, i) => (
                <div className="swiper-slide" key={i}>
                  <div className="card bg-secondary bg-opacity-50 bg-blur rounded-4 p-4 h-100">
                    <div className="card-body p-0 mb-4">
                      <ul className="list-inline mb-3">
                        {[...Array(Math.floor(t.stars))].map((_, idx) => (
                          <li className="list-inline-item me-0" key={idx}><i className="bi bi-star-fill text-warning"></i></li>
                        ))}
                        {t.stars % 1 !== 0 && <li className="list-inline-item me-0"><i className="bi bi-star-half text-warning"></i></li>}
                      </ul>
                      <blockquote><p className="heading-color mb-0">{t.text}</p></blockquote>
                    </div>
                    <div className="card-footer bg-transparent p-0">
                      <div className="d-flex align-items-center">
                        <div className="avatar flex-shrink-0">
                          <img className="avatar-img rounded-circle" src={`assets/images/avatar/${t.avatar}`} alt="avatar" />
                        </div>
                        <div className="ms-3">
                          <p className="lead heading-color fw-semibold mb-0">{t.name}</p>
                          <small>{t.role}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* ===================== CONTACT / SAY HELLO ===================== */}
      <section className="pb-0 overflow-hidden">
        <div className="bg-secondary-grad position-relative pb-8">
          {/* xml:space removed, style string → JSX object */}
          <span>
            <svg className="position-absolute top-0 start-0 mt-n3 mt-sm-n1" viewBox="0 0 1920 108" style={{ enableBackground: "new 0 0 1920 108" }}>
              <path className="fill-body" d="M0,0l1920,1.5V108L0,0z" />
            </svg>
          </span>

          <div className="container position-relative pt-5 pt-lg-0">
            <div className="row align-items-center g-4">

              <div className="col-lg-5">
                <span className="hand-wave-animate h2">🖐️</span>
                <h2 className="mb-3 h1">Say Hello</h2>
                <p>Our friendly team is ready to assist you with whatever you need.</p>

                <div className="row row-cols-1 row-cols-sm-2 g-4 mt-3 mt-md-5">
                  <div className="col">
                    <span className="fs-3 text-primary-grad"><i className="bi bi-headset"></i></span>
                    <h6 className="my-2 my-sm-3">Call us</h6>
                    <p className="mb-2">Let's work together towards a common goal — get in touch!</p>
                    <a href="tel:7677607080" className="heading-color hover-underline-animation">+91 76776 07080</a>
                  </div>
                  <div className="col">
                    <span className="fs-3 text-primary-grad"><i className="bi bi-envelope"></i></span>
                    <h6 className="my-2 my-sm-3">Email us</h6>
                    <p className="mb-2">We respond to all inquiries within 24 hours.</p>
                    <a href="mailto:info@arixautomation.com" className="heading-color hover-underline-animation">info@arixautomation.com</a>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 ms-auto mt-5 mt-lg-n7">
                <div className="card card-body rounded-4 shadow-primary-lg p-4">
                  <form className="row form-border-transparent g-3">
                    <div className="col-md-6">
                      <label className="form-label">First name</label>
                      <input type="text" className="form-control bg-secondary" />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Last name</label>
                      <input type="text" className="form-control bg-secondary" />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Email address</label>
                      <input type="email" className="form-control bg-secondary" placeholder="name@example.com" />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Mobile number</label>
                      <input type="text" className="form-control bg-secondary" />
                    </div>
                    <div className="col-12">
                      <label className="form-label">Subject</label>
                      <input type="text" className="form-control bg-secondary" />
                    </div>
                    <div className="col-12">
                      <label className="form-label">Message</label>
                      {/* style string → JSX object */}
                      <textarea className="form-control bg-secondary" style={{ height: "150px" }}></textarea>
                    </div>
                    <div className="col-12 mt-4">
                      <button className="btn btn-primary mb-2 mb-md-0">Send a message</button>
                    </div>
                  </form>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

    </main>
  );
}

export default WebDev;
